/* Copyright (c) 2025 MOCA Systems, Inc.  All rights reserved. */

// BEGIN PLACEHOLDER REPLACE AS PART OF TP-7411
// Finish or replace this with ticket

import dayjs from 'dayjs';
import duration, { Duration } from 'dayjs/plugin/duration';
dayjs.extend(duration);

export class DurationUtils {
	public static getDuration(durationHours: string): Duration {
		const { hours, minutes, seconds } = DurationUtils.getHoursMinutesSeconds(durationHours);
		return dayjs.duration({ hours, minutes, seconds });
	}

	public static getDurationFromDays(days: number): Duration {
		return dayjs.duration({ days });
	}

	public static formatDurationHours(hours: number, minutes: number, seconds: number) {
		const durationHours = dayjs.duration({ hours, minutes, seconds });
		return durationHours.format('HH:mm:ss');
	}

	public static getHoursMinutesSeconds(durationHours?: string) {
		let hours = 0;
		let minutes = 0;
		let seconds = 0;
		if (durationHours) {
			const parts = durationHours.split(':');
			if (parts.length > 2) {
				hours = Number.parseInt(parts[0], 10);
				minutes = Number.parseInt(parts[1], 10);
				seconds = Number.parseInt(parts[2], 10);
			}
		}
		return { hours, minutes, seconds };
	}
}

// END PLACEHOLDER REPLACE AS PART OF TP-7411
